module.exports = __webpack_public_path__ + "img/ez-slot-category-brand-hover.55eefcda.png";